import React from "react";

const Alert = ({type = "default", className, content, children}) => {
    const alertBaseClasses = "p-3 rounded-lg";
    const alertStyles = {
        default: "text-gray-800 bg-gray-50",
        danger: "text-[#9c2020] bg-[#fdf0f0] border border-[#f6abac]",
        success: "text-green-800 bg-green-100 border border-[#45ba47]",
        info: "text-blue-800 bg-blue-50"
    };
    const alertClassName = `${alertBaseClasses} ${alertStyles[type]} ${className || ''}`;
    return (
        <div className={alertClassName}>
            {content || ''}
            {children}
        </div>
    );
};

export default Alert;